import Vue from 'vue'

import routes from './routes'
import messages from './messages'

import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import VueSelect from 'vue-select'
import VeeValidate, {Validator} from "vee-validate";

import Main from './layouts/Main.vue'
import CustomInput from './components/input.vue'

import {alertModuleFactory} from './store/alert.module.js';
import {user} from './store/user.module.js';
import {file} from './store/file.module.js';

import Axios from "axios";
import Roles from "./models/Roles.js";
import Utils from "./services/utils.js";
import userService from "./services/userService.js";

Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(VueRouter);

Vue.component('v-select', VueSelect);
Vue.component('c-input', CustomInput);

// localisation

const dateTimeFormats = {
  'fr': {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  },
  'en': {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  }
};

if (localStorage.getItem('locale') !== 'fr' && localStorage.getItem('locale') !== 'en') {
  localStorage.setItem('locale', navigator.language.includes('fr') ? 'fr' : 'en');
}
const i18n = new VueI18n({
  locale: localStorage.getItem('locale'), // set locale
  fallbackLocale: 'en',
  messages,
  dateTimeFormats
});

// custom validations

const strongRegex = new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,})");
Validator.extend('password', value => {
  return strongRegex.test(value);
});

Vue.use(VeeValidate, {
  i18n,
  events: '', // disable auto-validation
  dictionary: {
    en: messages.en,
    fr: messages.fr,
  }
});

const alert = alertModuleFactory(i18n, Utils);
const store = new Vuex.Store({
  modules: {
    alert,
    user,
    file
  }
});

// routing

const router = new VueRouter({routes});

router.beforeEach((to, from, next) => {
  const authRequired = Utils.isNotPublic(to);
  if (authRequired && !userService.isLogged()) {
    store.dispatch('user/logout');
    return next({name: 'login'});
  }
  const currentUserRole = userService.getMyRole();
  if (!Utils.isAllowed(to, currentUserRole)) {
    return next('/');
  }
  if (to.path === '/') { // go to default page
    if (currentUserRole === Roles.superAdmin) {
      return next({name: 'adminList'});
    } else if (currentUserRole === Roles.admin) {
      return next({name: 'clientList'});
    } else {
      return next({name: 'myFiles'}); // TODO go to shared
    }
  }
  next();
});

// auth

// Add a request interceptor
Axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.common['Authorization'] = token;
  }
  config.headers.common['Content-Type'] = 'application/json; charset=utf-8';
  // config.withCredentials = true;
  // config.crossDomain = true;

  if (config.data && config.data.beforeSubmit) {
    config.data.beforeSubmit();
  }

  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

Axios.interceptors.response.use(
  function (response) {
    let token = response.headers.authorization;
    if (token) {
      localStorage.setItem('token', token);
    }
    return response;
  },
  function (error) {
    switch (error.response.status) {
      case 403:
        if (userService.isLogged()) {
          userService.logout();
          store.dispatch('user/logout');
          store.dispatch('alert/error', {message: i18n.t('http.403')});
          router.push({name: 'login'});
        }
        break;
      default:
        store.dispatch('alert/error', {message: null, error: error});
        break;
    }
    return Promise.reject(error);
  });

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<Main/>',
  components: {Main}
});

// import all SVG icons

function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context('./assets/', true, /\.svg$/));



// WEBPACK FOOTER //
// ./src/main.js